import React, { Component } from 'react';
import { NewClientModal } from '.';
import { ValidationModal } from '../components';
import DetailClientModal from './DetailClientModal';
import { CURRENCY, FORMAT_NUMBER, SYMBOL } from "../libs/utils/Const";

class ConsolidateDocsModal extends Component {



    render() {
        const { responseBOC } = this.props;
        return (
            <div>
                <div className="modal fade" id="consolidateDocsModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="consolidateDocsModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header" style={{ background: "#343a40" }}>
                                <div className="col-1 p-2">

                                </div>
                                <div className="col-9">

                                </div>
                                <div className="col-2 text-right p-2">
                                    <button type="button" className="close ml-3" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                            </div>
                            <div className="modal-body">
                                <div className="table-responsive scrollSearchs">
                                    <table className="table">
                                        <thead className='sticky-headerPOS'>
                                            <tr>
                                                <th scope="col" className="border-0 bg-light">
                                                    <div className="py-2 text-uppercase">Documento</div>
                                                </th>
                                                <th scope="col" className="border-0 bg-light">
                                                    <div className="p-2 px-3 text-uppercase">Mensaje</div>
                                                </th>
                                                <th scope="col" className="border-0 bg-light">
                                                    <div className="py-2 text-uppercase">Pago</div>
                                                </th>
                                                <th scope="col" className="border-0 bg-light">
                                                    <div className="p-2 px-3 text-uppercase"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th scope="row" className="border-0" >

                                                </th>
                                                <td className="align-middle" >
                                                </td>
                                                <td className="align-middle" >
                                                </td>
                                                <td className="align-middle" >
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer"></div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default ConsolidateDocsModal;